/*
Verify Code Form. This form presents itself when a new User is authenticating
for the first time and they have NOT provided a DOB value in their setup in the webapp.
They are presented with a special code input to verify their auth instead of DOB.
*/
import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains } from 'ramda';
import { Link, withRouter } from 'react-router';

// Redux
import { connect } from 'react-redux';
import { verifyCode } from '../../../actions/session/sessionActions';
import * as SessionTypes from '../../../actions/session/types';

import LoadingState from '../../LoadingState/index';
import { setLoggedIn } from '../../../lib/auth';

// Page styles
import cx from 'classnames';
import s from './VerifyCodeForm.css';


export class VerifyCodeForm extends Component {
  static propTypes = {
    loading: object,
    location: object,
    history: object,
    match: object,
    verifyCode: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      code: '',
      errorMessage: '',
    };
  }

  clearErrorMessage = () => {
    if (this.state.errorMessage) this.setState({ errorMessage: '' });
  };

  isValidCode = code => code;

  isLoading = (loading) => contains(SessionTypes.VERIFY_CODE_REQUEST, loading.requests);

  handleInputChange = (event) => this.setState({ code: event.target.value });

  handleSubmit = () => {
    if (this.isValidCode(this.state.code)) {
      this.clearErrorMessage();

      const successCallback = response => {
        const route = response.route;
        setLoggedIn(route, response.logoutUrl);

        /**
         * Successful responses return a route (home, resetpassword, etc.) indicating
         * where to transition the end user to based on a calculated session state
         * from the server side.
         */
        this.props.router.replace(`/${route}`);
      };

      const errorCallback = response => this.setState({ errorMessage: response.message.body });

      this.props.verifyCode(this.state.code, successCallback, errorCallback)
    }
  };

  render = () => {
    const isLoading = this.isLoading(this.props.loading);
    const isValidCode = this.isValidCode(this.state.code);

    return (
      <form
        className={s.component}
        id="verifyCodeForm"
      >
        <h3 className={cx(s.header, s.verticalSpacing)}>
          Verify Your Account
        </h3>
        <label className={cx(s.secondaryText, s.verticalSpacing)} htmlFor="code">
          Please enter your code.
        </label>
        <input
          className={cx(s.input, s.verticalSpacing)}
          id="code"
          name="code"
          maxLength="32"
          onChange={this.handleInputChange}
          type="text"
          value={this.state.code}
        />
        <button
          className={cx(s.btn, s.verticalSpacing)}
          id="submitVerifyDob"
          disabled={!isValidCode || isLoading}
          onClick={this.handleSubmit}
          type="button"
        >
          {isLoading ?
            <LoadingState context="verifyDobForm"/> :
            'Verify'
          }
        </button>
        <Link
          className={cx(s.link, s.verticalSpacing)}
          id="cancelVerifyDob"
          title="Cancel"
          to={`/login`}
        >
          Cancel
        </Link>
        {this.state.errorMessage &&
        <p className={cx(s.message, s.verticalSpacing)}>
          {this.state.errorMessage}
        </p>
        }
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
  verifyCode: (code, successCb, errorCb) => dispatch(verifyCode(code, successCb, errorCb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VerifyCodeForm));



// WEBPACK FOOTER //
// ./src/components/Pages/VerifyCode/VerifyCodeForm.js